import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EMPTY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {FibcTeamsContent} from './FibcTeamsContent';
import reportPayload from './reportPayload';

export const FibcTeamsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'FIBC Teams')}
      description={tt(
        'description',
        'These Coaches have either qualified as FIBC or have a FIBC in their downline.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={FibcTeamsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.fibcTeamsReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EMPTY,
    popoverContentProps: {},
  }),
)(FibcTeamsReport);
